import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { Input } from "@ember/component";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { eq } from "discourse/truth-helpers";
import DButton from "discourse/ui-kit/d-button";
import DModal from "discourse/ui-kit/d-modal";
import { i18n } from "discourse-i18n";
import {
  buildGroup,
  groupName,
  isPositiveInteger,
} from "../lib/category-groups";

export default class FrlEditGroup extends Component {
  @tracked selectedGroupId = this.group?.id;
  @tracked postLimit = this.group?.post_limit;
  @tracked topicLimit = this.group?.topic_limit;
  @tracked cooldown = this.group?.cooldown;

  get group() {
    return this.args.model.group;
  }

  get availableGroups() {
    const groupIds = this.args.model.currentGroups.map((group) => group.id);

    return this.args.model.groups.filter(
      (group) => !groupIds.includes(group.id)
    );
  }

  get formValues() {
    return {
      id: parseInt(this.selectedGroupId, 10),
      topic_limit: parseInt(this.topicLimit, 10),
      post_limit: parseInt(this.postLimit, 10),
      cooldown: parseInt(this.cooldown, 10),
    };
  }

  get disabled() {
    return !Object.values(this.formValues).every(isPositiveInteger);
  }

  @action
  selectGroup(event) {
    this.selectedGroupId = parseInt(event.target.value, 10);
  }

  @action
  save() {
    if (this.disabled) {
      return;
    }

    if (this.group) {
      Object.assign(this.group, this.formValues);
    } else {
      this.args.model.currentGroups.push(buildGroup(this.formValues));
    }

    this.args.closeModal();
  }

  <template>
    <DModal
      @closeModal={{@closeModal}}
      @title={{i18n "flexible_rate_limits.admin.group"}}
      id="frl-edit-group-modal"
    >
      <:body>
        <table class="flr-table-modal">
          <tbody>
            <tr>
              <td class="frl-label">{{i18n "flexible_rate_limits.admin.group"}}</td>
              <td>
                <select {{on "change" this.selectGroup}}>
                  <option value="">{{i18n
                      "flexible_rate_limits.admin.select_group"
                    }}</option>
                  {{#if this.group.id}}
                    <option
                      value={{this.group.id}}
                      selected={{eq this.group.id this.selectedGroupId}}
                    >{{groupName @model.groups this.group.id}}</option>
                  {{/if}}

                  {{#each this.availableGroups as |g|}}
                    <option
                      value={{g.id}}
                      selected={{eq g.id this.selectedGroupId}}
                    >{{groupName @model.groups g.id}}</option>
                  {{/each}}
                </select>
              </td>
            </tr>

            <tr>
              <td class="frl-label">{{i18n
                  "flexible_rate_limits.admin.post_limit"
                }}</td>
              <td><Input @type="number" @value={{this.postLimit}} min="1" /></td>
            </tr>

            <tr>
              <td class="frl-label">{{i18n
                  "flexible_rate_limits.admin.topic_limit"
                }}</td>
              <td><Input
                  @type="number"
                  @value={{this.topicLimit}}
                  min="1"
                /></td>
            </tr>

            <tr>
              <td class="frl-label">{{i18n
                  "flexible_rate_limits.admin.cooldown"
                }}</td>
              <td><Input @type="number" @value={{this.cooldown}} min="1" /></td>
            </tr>
          </tbody>
        </table>
      </:body>

      <:footer>
        <DButton
          @action={{this.save}}
          @label="flexible_rate_limits.admin.save"
          @disabled={{this.disabled}}
          class="btn-large btn-primary"
        />
      </:footer>
    </DModal>
  </template>
}
